import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { PartnersService } from "src/app/partner/services/partners/partners.service";
import { UserService } from "./core/auth/user.service";

export const hasPartnersGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const partners = inject(PartnersService);
  const user = inject(UserService);

  await user.isLoaded;
  const hasPartners = await partners.load();
  return hasPartners ? true : router.parseUrl("/account-pending");
};
